export default function(instance) {
  return {
    getAccounts(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/personal_accounts/admin/", { params: data });
    },
    createAccount(data) {
      return instance.post("/api/personal_accounts/admin/", {
        user: data.user,
        account: data.account,
        saldo: data.saldo
      });
    },
    getAccount(idAccount) {
      return instance.get(`/api/personal_accounts/admin/${idAccount}/`);
    },
    updateAccount(idAccount, data) {
      return instance.put(`/api/personal_accounts/admin/${idAccount}/`, {
        user: data.user,
        account: data.account,
        saldo: data.saldo
      });
    },
    deleteAccount(idAccount) {
      return instance.delete(`/api/personal_accounts/admin/${idAccount}/`);
    }
  };
}
